import { relations } from 'drizzle-orm'
import { date, decimal, pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getMonetaryField,
} from '../common/utils'
import { properties } from './property'

// Consumption type enum
export const consumptionTypeEnum = pgEnum('consumption_type', [
  'electricity',
  'water',
  'heating',
])

export const consumptions = pgTable(
  'consumptions',
  {
    ...getBaseFields(),
    propertyId: getIdReference(() => properties.id),
    type: consumptionTypeEnum().notNull(),
    date: date().notNull(),
    meterReading: decimal({ precision: 10, scale: 2 }).notNull(), // Meter reading (source of truth)
    unit: text().notNull(), // Unit of measurement (kWh, m³, MWh)
    cost: getMonetaryField(),
    notes: text(),
  },
  (table) => getBaseIndexes('consumptions', table),
)

export const consumptionsRelations = relations(consumptions, ({ one }) => ({
  property: one(properties, {
    fields: [consumptions.propertyId],
    references: [properties.id],
  }),
}))
